import { Period, createEarlierYearPeriods, formatFullRange } from "../../periods";

export const toDropdownOption = (period: Period, group?: string) => {
  const range = formatFullRange(period);
  return {
    value: period.key,
    label: period.label,
    // A custom range is already named by its dates
    detail: period.label === range ? undefined : range,
    group,
  };
};

// What a focus can sensibly be compared with: a reporting year with the reporting years, and a
// period made of days with the same days in the years before it, as far back as the oldest
// reporting year, so a Past 6 Months is only ever compared across years
export const getComparisonChoices = (
  focusPeriod: Period,
  reportingYears: Period[],
  timeZone: string,
): Period[] => {
  if (!focusPeriod.sameDatesLastYear) return reportingYears;
  const oldestYear =
    reportingYears[reportingYears.length - 1]?.firstDay.year ?? focusPeriod.firstDay.year - 1;
  return createEarlierYearPeriods(
    focusPeriod,
    Math.max(1, focusPeriod.firstDay.year - oldestYear),
    timeZone,
  );
};
